'use strict';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
/*!
 * Copyright (c) 2020 Digital Bazaar, Inc. All rights reserved.
 * Implementing @digitalbazaar/bitstring
 */
function isNumber(value, name) {
  if (typeof value !== "number") {
    throw new TypeError(`"${name}" must be number.`);
  }
}
__name(isNumber, "isNumber");
function isPositiveInteger(value, name) {
  if (!(Number.isInteger(value) && Number(value) > 0)) {
    throw new TypeError(`"${name}" must be a positive integer.`);
  }
}
__name(isPositiveInteger, "isPositiveInteger");
function isString(value, name) {
  if (typeof value !== "string") {
    throw new TypeError(`"${name}" must be a string.`);
  }
}
__name(isString, "isString");
function isBoolean(value, name) {
  if (typeof value !== "boolean") {
    throw new TypeError(`"${name}" must be a Boolean.`);
  }
}
__name(isBoolean, "isBoolean");
function isNonNegativeInteger(value, name) {
  if (!(Number.isInteger(value) && Number(value) >= 0)) {
    throw new TypeError(`"${name}" must be a non-negative integer.`);
  }
}
__name(isNonNegativeInteger, "isNonNegativeInteger");
function isUint8Array(value, name) {
  if (!(value instanceof Uint8Array)) {
    throw new TypeError(`"${name}" must be a Uint8Array.`);
  }
}
__name(isUint8Array, "isUint8Array");
function assertAllowedStatusPurpose(statusPurpose) {
  const ALLOWED_STATUS_PURPOSES = [
    "revocation",
    "suspension"
  ];
  if (!ALLOWED_STATUS_PURPOSES.includes(statusPurpose)) {
    throw new Error(`Unsupported statusPurpose: statusPurpose must be "revocation" or "suspension".`);
  }
}
__name(assertAllowedStatusPurpose, "assertAllowedStatusPurpose");
const assertStatusListIndexWithinRange = /* @__PURE__ */ __name((bitstringStatusList, index) => {
  if (bitstringStatusList.length <= index || index < 0) {
    throw new Error(`Invalid statusListIndex: Index out of range: min=0, max=${bitstringStatusList.length - 1}`);
  }
}, "assertStatusListIndexWithinRange");
function _checkCredentialSubjectForStatusList2021Credential(credentialSubject) {
  if (!credentialSubject) {
    throw new Error("Credential subject must be an object.");
  }
  if (!credentialSubject?.type) {
    throw new Error("Credential subject must have a type.");
  }
  if (credentialSubject.type !== "StatusList2021") {
    throw new Error('Invalid type for credentialSubject: Credential subject for StatusList2021Credential must have type "StatusList2021".');
  }
  if (!credentialSubject?.statusPurpose) {
    throw new Error("Credential subject must have a statusPurpose.");
  }
  assertAllowedStatusPurpose(credentialSubject.statusPurpose);
  if (!Object.keys(credentialSubject).includes("encodedList")) {
    throw new Error("Credential subject must have an encodedList.");
  }
  if (!credentialSubject?.encodedList?.length) {
    throw new Error("Credential subject must have a non-empty encodedList.");
  }
}
__name(_checkCredentialSubjectForStatusList2021Credential, "_checkCredentialSubjectForStatusList2021Credential");

exports._checkCredentialSubjectForStatusList2021Credential = _checkCredentialSubjectForStatusList2021Credential;
exports.assertAllowedStatusPurpose = assertAllowedStatusPurpose;
exports.assertStatusListIndexWithinRange = assertStatusListIndexWithinRange;
exports.isBoolean = isBoolean;
exports.isNonNegativeInteger = isNonNegativeInteger;
exports.isNumber = isNumber;
exports.isPositiveInteger = isPositiveInteger;
exports.isString = isString;
exports.isUint8Array = isUint8Array;
